import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '../slices/auth.slice';

const selectDomain = (state: RootState) => state.authState || initialState;

export const selectIsLoggedIn = createSelector(
  [selectDomain],
  authState => authState.isLoggedIn,
);

export const selectLoggedInUser = createSelector(
  [selectDomain],
  authState => authState.user,
);
